import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { RegistrationService } from "./registration.service";
import { Router } from "@angular/router";
import { RegistrationModel } from "./registration.models";
import { Error } from "@bt/shared";

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html'
})
export class RegistrationComponent {
    public showLoader: boolean = false;
    public error: Error;

    constructor(private service: RegistrationService, private router: Router) { }

    public register(model: RegistrationModel) {
        if (!this.showLoader) {
            this.showLoader = true;
            this.service
                .register(model)
                .subscribe(
                    (response) => {

                        localStorage.setItem("activationSessionId", response.data.sessionId);
                        this.router.navigateByUrl('courses')
                            .then(() => this.showLoader = false);
                    },
                    (error: HttpErrorResponse) => {
                        this.error = error.error;

                        this.showLoader = false;
                    }
                );
        }
    }

    public clearError() {
        this.error = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/public/registration/registration.component.ts